module.exports = __webpack_public_path__ + "static/img/earn-rewards@3x.acaba17e.png";